import {
    TreatmentFileKind,
    TreatmentFileTypeEnum,
} from '../treatment-file.model';

export interface RequiredDesignFileTemplateDoctorDeliveryFile {
    readonly fileType: TreatmentFileTypeEnum | number;
    readonly fileKind: TreatmentFileKind;
    readonly label: string;
}

export interface RequiredDesignFileTemplateBody {
    readonly requiredDoctorDeliveryFiles: ReadonlyArray<RequiredDesignFileTemplateDoctorDeliveryFile>;
}
